var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfiguration01 = function SvgConfiguration01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "configuration-01_svg2__a",
    x1: -0.91,
    x2: 175.65,
    y1: 154.15,
    y2: 15.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#configuration-01_svg2__a",
    id: "configuration-01_svg2__b",
    x1: -37.64,
    x2: 138.92,
    y1: 107.41,
    y2: -31.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#configuration-01_svg2__a",
    id: "configuration-01_svg2__c",
    x1: 32.1,
    x2: 208.67,
    y1: 196.18,
    y2: 57.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#configuration-01_svg2__a",
    id: "configuration-01_svg2__d",
    x1: -4.62,
    x2: 171.94,
    y1: 149.43,
    y2: 10.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#configuration-01_svg2__a",
    id: "configuration-01_svg2__e",
    x1: 62.85,
    x2: 239.41,
    y1: 235.31,
    y2: 96.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#configuration-01_svg2__a",
    id: "configuration-01_svg2__f",
    x1: 26.12,
    x2: 202.69,
    y1: 188.56,
    y2: 49.83
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M185.71 46.43h-84.57c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57h84.57c7.89 0 14.29-6.4 14.29-14.29s-6.4-14.29-14.29-14.29h-84.57c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57h84.57c3.94 0 7.14 3.2 7.14 7.14s-3.2 7.14-7.14 7.14Z",
    style: {
      fill: "url(#configuration-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29 53.57h21.69c4.94 8.54 14.17 14.29 24.74 14.29 15.78 0 28.57-12.79 28.57-28.57S76.5 10.72 60.72 10.72c-10.57 0-19.8 5.75-24.74 14.29H14.29C6.4 25.01 0 31.41 0 39.3s6.4 14.29 14.29 14.29Zm46.42-35.71c11.83 0 21.43 9.59 21.43 21.43s-9.59 21.43-21.43 21.43-21.43-9.59-21.43-21.43 9.59-21.43 21.43-21.43M14.29 32.14h18.76c-.59 2.28-.9 4.68-.9 7.14s.31 4.86.9 7.14H14.29c-3.94 0-7.14-3.2-7.14-7.14s3.2-7.14 7.14-7.14",
    style: {
      fill: "url(#configuration-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71 85.71h-14.55c-4.94-8.54-14.17-14.29-24.74-14.29-15.78 0-28.57 12.79-28.57 28.57s12.79 28.57 28.57 28.57c10.57 0 19.8-5.75 24.74-14.29h14.55c7.89 0 14.29-6.4 14.29-14.29s-6.4-14.29-14.29-14.29Zm-39.28 35.72c-11.83 0-21.43-9.59-21.43-21.43s9.59-21.43 21.43-21.43 21.43 9.59 21.43 21.43-9.59 21.43-21.43 21.43m39.28-14.29H174.1c.59-2.28.9-4.68.9-7.14s-.31-4.86-.9-7.14h11.61c3.94 0 7.14 3.2 7.14 7.14s-3.2 7.14-7.14 7.14",
    style: {
      fill: "url(#configuration-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29 114.29H106c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57H14.29c-3.94 0-7.14-3.2-7.14-7.14s3.2-7.14 7.14-7.14H106c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57H14.29C6.4 85.73 0 92.13 0 100.02s6.4 14.29 14.29 14.29Z",
    style: {
      fill: "url(#configuration-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71 146.43h-59.57c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57h59.57c3.94 0 7.14 3.2 7.14 7.14s-3.2 7.14-7.14 7.14h-59.57c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57h59.57c7.89 0 14.29-6.4 14.29-14.29s-6.4-14.29-14.29-14.29Z",
    style: {
      fill: "url(#configuration-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.71 132.14c-10.57 0-19.8 5.75-24.74 14.29H14.29C6.4 146.43 0 152.83 0 160.72s6.4 14.29 14.29 14.29h46.69c4.94 8.54 14.17 14.29 24.74 14.29 15.78 0 28.57-12.79 28.57-28.57s-12.79-28.57-28.57-28.57Zm-71.42 35.72c-3.94 0-7.14-3.2-7.14-7.14s3.2-7.14 7.14-7.14h43.76c-.59 2.28-.9 4.68-.9 7.14s.31 4.86.9 7.14zm71.42 14.28c-11.83 0-21.43-9.59-21.43-21.43s9.59-21.43 21.43-21.43 21.43 9.59 21.43 21.43-9.59 21.43-21.43 21.43",
    style: {
      fill: "url(#configuration-01_svg2__f)"
    }
  }));
};
export default SvgConfiguration01;